import React, { memo, useCallback } from 'react';

import { Box } from '@mui/material';
import { DeleteIcon } from '@sharedCR/coreDesignSystem/icons';
import ButtonWithTooltip from 'app/shared/components/common/ButtonWithTooltip';
import PropTypes from 'prop-types';

import { FieldTypesEnum } from 'constants/loanActionEditor';

import { loanManagementTestIds } from '../../../../loanManagement.testIds';
import { DynamicValueInput } from '../../../LoanActionItems';

const SupportingDocumentRow = ({
  rowPath,
  rowIndex,
  documentTypesOptions,
  vendorDocType,
  disabled,
  onDelete,
}) => {
  const onDeleteRow = useCallback(() => onDelete(rowIndex), [onDelete, rowIndex]);

  return (
    <Box className="flex items-start gap-2">
      <DynamicValueInput
        required
        className="grow"
        disabled={disabled}
        label="Document type"
        name={`${rowPath}.documentType`}
        options={documentTypesOptions}
        type={FieldTypesEnum.SELECT}
      />
      {vendorDocType && (
        <DynamicValueInput
          required
          className="grow"
          disabled={disabled}
          label={vendorDocType.label}
          name={`${rowPath}.${vendorDocType.key}`}
          options={vendorDocType.options}
          type={FieldTypesEnum.SELECT}
        />
      )}
      {!disabled && (
        <ButtonWithTooltip
          data-testid={loanManagementTestIds.getDeleteRowButtonId(rowPath)}
          icon={DeleteIcon}
          size="medium"
          spanContainerClassName="flex items-center self-center"
          title="Remove supporting document"
          onClick={onDeleteRow}
        />
      )}
    </Box>
  );
};

SupportingDocumentRow.propTypes = {
  rowPath: PropTypes.string.isRequired,
  rowIndex: PropTypes.number.isRequired,
  documentTypesOptions: PropTypes.array.isRequired,
  disabled: PropTypes.bool.isRequired,
  onDelete: PropTypes.func.isRequired,
  vendorDocType: PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
  }),
};

export default memo(SupportingDocumentRow);
